import React, { useState } from "react";
import { Link } from "react-router-dom";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import axios from "axios";
import API_BASE_URL from "./../../common/config";
import {
  ErrorNotification,
  SuccessNotification,
} from "../../tosterNotification/tosters";
import API_URL from "./../../common/config";

const GoogleSignUp = ({
  formValues,
  setFormValues,
  formErrors,
  setFormErrors,
  setOtpSent,
  setGoogleVerified,
  setIsLoading,
  setOtpVerified,
  auth,
  otpSent,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleGoogleSignUp = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const { email, displayName } = result.user;
      const response = await axios.post(`${API_URL}/auth/check-user`, {
        email: email,
      });
      if (response.data.success) {
        ErrorNotification("User with this email already exists !");
        return;
      }
      const nameParts = displayName.split(" ");
      setFormValues((prev) => ({
        ...prev,
        firstname: nameParts[0],
        lastname: nameParts.length > 1 ? nameParts[1] : "",
        email,
        password: "",
      }));
      setOtpVerified(true);
      setGoogleVerified(true);
    } catch (error) {
      console.error("Google sign up error:", error);
      setFormErrors((prev) => ({
        ...prev,
        google: "Google sign up failed. Please try again.",
      }));
    }
  };

  const sendOtp = async (email) => {
    try {
      setIsLoading(true);

      const user = await axios.post(`${API_URL}/auth/check-user`, {
        email: email,
      });

      if (user.data.success) {
        ErrorNotification("User already exists !");
        return;
      } else {
        const response = await axios.post(`${API_BASE_URL}/auth/send-otp`, {
          email,
        });
        if (response.data.success) {
          setOtpSent(true);
          SuccessNotification("OTP Sent Successfully!");
        } else {
          ErrorNotification("Failed to send OTP");
          throw new Error("Failed to send OTP");
        }
      }
    } catch (error) {
      console.error("OTP Send Error:", error);
      ErrorNotification("Error sending OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const validate = (values) => {
    const errors = {};
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const passwordRegEx =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/; // Correct regex object

    if (!values.firstname) errors.firstname = "First name is required";
    if (!values.lastname) errors.lastname = "Last name is required";
    if (!values.email) errors.email = "Email is required";
    else if (!regex.test(values.email)) errors.email = "Invalid email format";

    if (!values.password) errors.password = "Password is required";
    else if (!passwordRegEx.test(values.password))
      // Correct validation
      errors.password =
        "Password must have at least 8 characters, including uppercase and lowercase letters, a number, and a special character.";

    // if (!values.cpassword) errors.cpassword = "Confirm password is required";
    // else if (values.password !== values.cpassword)
    //   errors.cpassword = "Passwords do not match";

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate(formValues);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      sendOtp(formValues.email);
    }
  };

  return (
    <>
      <h3
        className="title text-center mb-n1 pt-0 "
        style={{ textTransform: "capitalize" }}>
        Join CLIF — Create your account !
      </h3>
      <h5 className="text-center mt-1">
        Already a Member?{" "}
        <Link to="/login" style={{ color: "#6600CC" }}>
          Sign In
        </Link>
      </h5>
      <button
        type="button"
        onClick={handleGoogleSignUp}
        className="btn btn-light d-flex align-items-center justify-content-center w-100"
        style={{
          height: "50px",
          marginTop: "5px",
          borderRadius: "12px",
          background:
            "linear-gradient(135deg,rgb(228, 219, 244),rgb(194, 163, 238))",
          color: "#4a3f75",
          fontWeight: "500",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) =>
          (e.target.style.background =
            "linear-gradient(135deg, #e9dfff, #c79fff)")
        }
        onMouseOut={(e) =>
          (e.target.style.background =
            "linear-gradient(135deg, #f5f0ff, #d6b8ff)")
        }>
        <img
          src="https://www.svgrepo.com/show/452216/google.svg"
          alt="Google"
          className="me-2"
          style={{ height: "20px" }}
        />
        Sign Up with Google
      </button>
      <div className="d-flex align-items-center justify-content-center mt-3">
        <hr className="flex-grow-1" />
        <span className="mx-2" f>
          or
        </span>
        <hr className="flex-grow-1" />
      </div>
      <form onSubmit={handleSubmit} className="axil-contact-form">
        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <label
                style={{ textTransform: "capitalize" }}
                className="fw-bold">
                First Name *
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="First name"
                name="firstname"
                value={formValues.firstname}
                onChange={handleChange}
              />
            </div>
            <p className="text-red">{formErrors.firstname}</p>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label
                style={{ textTransform: "capitalize" }}
                className="fw-bold">
                Last name *
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Last name"
                name="lastname"
                value={formValues.lastname}
                onChange={handleChange}
              />
            </div>
            <p className="text-red">{formErrors.lastname}</p>
          </div>
        </div>
        <div className="form-group">
          <label style={{ textTransform: "capitalize" }} className="fw-bold">
            Email address*
          </label>
          <input
            type="email"
            className="form-control"
            placeholder="name@gmail.com"
            name="email"
            value={formValues.email}
            onChange={handleChange}
            disabled={otpSent}
          />
        </div>
        <p className="text-red">{formErrors.email}</p>
        <div className="form-group">
          <label className="fw-bold">Password *</label>
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}>
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              placeholder="Ex : Secure2@Pass"
              name="password"
              value={formValues.password}
              onChange={handleChange}
              style={{
                paddingRight: "40px", // space for eye icon
              }}
            />
            <i
              className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "12px",
                cursor: "pointer",
                color: "#888",
                fontSize: "18px",
              }}></i>
          </div>
        </div>
        <p className="text-red">{formErrors.password}</p>

        <div className="form-group text-start">
          <div className="form-check d-flex">
            <input
              type="checkbox"
              className="form-check-input"
              id="checkbox"
              name="checkbox"
              required
            />
            <label className="form-check-label mt-0" htmlFor="checkbox">
              I agree to the with{" "}
              <Link to="/terms-use" target="#">
                <u> Terms of services </u>
              </Link>{" "}
              and{" "}
              <Link to="/privacy-policy" target="#1">
                <u>privacy policy</u>
              </Link>
            </label>
          </div>
        </div>
        <div className="form-group gap-2 flex">
          <button
            type="submit"
            className="axil-btn btn-fill-primary btn-fluid btn-primary"
            name="submit-btn">
            Sign Up
          </button>
        </div>
        {formErrors.google && (
          <p className="text-red text-center mt-2">{formErrors.google}</p>
        )}
      </form>
      <style>{`
        .mx-2 {
    margin-right: .5rem !important;
    margin-left: .5rem !important;
    margin-top: -32px!important;
   margin-bottom: 0px !important;
   padding-bottom:0px !important;sf
}
      `}</style>
    </>
  );
};

export default GoogleSignUp;
